import CloseIcon from '@/components/Icons/CloseIcon';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { Fragment } from 'react';
import lockImage from '@/assets/images/lock.png';
import CopyIcon from '../Icons/CopyIcon';
import { IconButton } from '@mui/material';
import { freeTrialMailtoHref } from '@/utils/freeTrial';

interface FreeTrialModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const contactAddress = 'info@scribl.co';

export default function FreeTrialModal({ isOpen, onClose }: FreeTrialModalProps) {
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(contactAddress);
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed z-40" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-50"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/50 backdrop-filter transition-opacity" />
        </TransitionChild>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel
                className={`transform rounded-xs text-center align-middle elevated transition-all bg-white py-32 px-100  relative`}
              >
                <div className="w-408 flex flex-col items-center">
                  <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                      position: 'absolute',
                      right: 24,
                      top: 24
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <img src={lockImage} className="w-178 text-center" />
                  <h2 className="text-h2 mt-24 mb-4">Your Free Trial Has Ended</h2>
                  <p className="text-body text-neutral-400 text-center">
                    To continue using Scribl, you need to upgrade to a paid plan. Please contact the
                    Scribl team to learn about available plans and next steps.
                  </p>
                  <a className="btn btn-primary mb-16 mt-24 w-full" href={freeTrialMailtoHref}>
                    Contact Us
                  </a>
                  <p className="text-body-sm text-center text-neutral-400 flex items-center gap-4">
                    {`Or email us at ${contactAddress}`}
                    <button className="link link-sm" onClick={handleCopyToClipboard}>
                      <CopyIcon />
                    </button>
                  </p>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
